<div class="gender-per-age-chart-header">
  <div class="chart-title">{{'INFLUENCER.CHART.NEW_GENDER_PER_AGE.TITLE' | translate}}</div>
  <div class="tooltip-title-wrapper">
    <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.gender_per_age' | translate"></achoo-icon-tooltip>
  </div>
  <div class="col-sm y-axis-percent-symbol" *ngIf="!isPlaceholder">%</div>
</div>
<div class="list-container d-flex flex-row" *ngIf="!isPlaceholder">
  <div class="d-flex flex-row new-chart-container">
    <div class="d-flex flex-row list-item" *ngFor="let item of chartData">
      <div class="d-flex flex-column list-individual-item">
        <div class="d-flex flex-row bar-chart-container">
          <div class="bar-container d-flex flex-column justify-content-end">
            <div class="d-flex justify-content-center percentage">
              <span>{{item.f}}%</span>
            </div>
            <div class="bar blue female-bar" [style.height.%]="getBarHeight(item.f)"
              [style.backgroundColor]="barFemaleColor">
            </div>
          </div>
          <div class="bar-container d-flex flex-column justify-content-end">
            <div class="d-flex justify-content-center percentage">
              <span>{{item.m}}%</span>
            </div>
            <div class="bar green male-bar" [style.height.%]="getBarHeight(item.m)"
              [style.backgroundColor]="barMaleColor">
            </div>
          </div>
        </div>
        <div class="text-center center-item">
          <div class="d-flex flex-row full-height">
            <div class="d-flex range-container justify-content-center">
              <div class="range">{{formatRangeVaule(item.range)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="y-axis-container">
    <div class="col-sm no-padding y-axis-percent-item" *ngFor="let item of yAxis">
      <span>{{item}}</span>
    </div>
  </div>
</div>
<div class="chart-placeholder" *ngIf="isPlaceholder">
  <div class="chart-placeholder-content" [innerHTML]="'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/new-gender-per-age-chart/new-gender-per-age-chart.component.html